import TableUtil from "./TableUtil";

export default class AuthUtil {

    constructor(table, document) {
        this.table = table
        this.document = document
        this.tableUtil = new TableUtil()
    }

    getEmail() {
        let field = this.tableUtil.getFieldByName(this.table, 'email')
        return this.document[field.index]
    }

    getName() {
        let field = this.tableUtil.getFieldByName(this.table, 'name')
        return this.document[field.index]
    }

    getPassword() {
        let field = this.tableUtil.getFieldByName(this.table, 'password')
        return this.document[field.index]
    }
}